var _path, _path2, _path3, _path4;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconCash02(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12 18c-1.332.622-3.083 1-5 1-1.066 0-2.08-.117-3-.327-.591-.136-.887-.203-1.241-.484a2.367 2.367 0 01-.565-.709C2 17.073 2 16.677 2 15.886V5.114c0-.985 1.04-1.661 2-1.441.92.21 1.934.327 3 .327 1.917 0 3.668-.378 5-1 1.332-.622 3.083-1 5-1 1.066 0 2.08.117 3 .327.591.136.887.204 1.241.484.202.16.454.476.565.709.194.408.194.803.194 1.594v10.772c0 .985-1.04 1.661-2 1.441-.92-.21-1.934-.327-3-.327-1.917 0-3.668.378-5 1z",
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M2 21c1.333.622 3.083 1 5 1 1.917 0 3.668-.378 5-1 1.332-.622 3.083-1 5-1 1.917 0 3.668.378 5 1",
    stroke: "#376E66",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M14.5 10.5a2.5 2.5 0 11-5 0 2.5 2.5 0 015 0z",
    stroke: "#376E66",
    strokeWidth: 1.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M5.5 11.5v.009M18.5 9.492v.01",
    stroke: "#376E66",
    strokeWidth: 2,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
export default SvgIconCash02;